import api from './api';
import type { CareerStage, CareerStageRequest, CareerSummary, CareerHistory, ApiResponse } from '@/types/api.types';

export const careerApi = {
  getStages: () =>
    api.get('/career/stages/') as Promise<{ data: { results: CareerStage[] } }>,

  getStage: (id: number) =>
    api.get(`/career/stages/${id}/`) as Promise<{ data: CareerStage }>,

  createStage: (payload: CareerStageRequest) =>
    api.post('/career/stages/', payload) as Promise<{ data: CareerStage }>,

  updateStage: (id: number, payload: CareerStageRequest) =>
    api.put(`/career/stages/${id}/`, payload) as Promise<{ data: CareerStage }>,

  deleteStage: (id: number) =>
    api.delete(`/career/stages/${id}/`) as Promise<unknown>,

  getSummary: () =>
    api.get('/career/stages/summary/') as Promise<{ data: ApiResponse<CareerSummary> }>,

  getHistory: () =>
    api.get('/career/stages/history/') as Promise<{ data: ApiResponse<CareerHistory> }>,
};
